export default __webpack_public_path__ + "static/media/451.e1e938f9.gif";